import { DEFAULT_LAYOUT } from '../base';
import { type AppRouteRecordRaw } from '../types';
import { IconEmail } from "@arco-design/web-vue/es/icon";


const routes: AppRouteRecordRaw = {
  path: '/talent-evaluation',
  redirect: '/talent-evaluation/index',
  component: DEFAULT_LAYOUT,
  meta: {
    title: '评价中心',
    icon: IconEmail,
    // hideChildrenInMenu: true,
    order: 200,
    roles: ['authorized-org-admin', 'admin'],
    // roles: ['system-admin', 'admin'],
  },
  children: [
    {
      path: 'quickly',
      component: () => import('@/views/talent-evaluation/evaluation-quick.vue'),
      meta: {
        title: '快速评价',
      },
    },
    {
      path: 'index',
      component: () => import('@/views/talent-evaluation/index.vue'),
      meta: {
        title: '深度评价',
      },
    },
    {
      path: 'evaluation-history',
      component: () => import('@/views/talent-evaluation/evaluation-history.vue'),
      meta: {
        title: '历史评价',
      },
    },
    {
      path: 'my-assessment/:batchNo?/:userId?/:userType?',
      props: true,
      component: () => import('@/views/user-details/my-assessment.vue'),
      meta: {
        hideInMenu: true,
        title: '我的评价',
        activeMenu: '/talente-valuation/evaluation-history',
      },
    },
    {
      path: 'evaluation-details/:id',
      component: () => import('@/views/talent-evaluation/components/evaluation-history/evaluation-details.vue'),
      props: true,
      meta: {
        title: '评价详情',
        hideInMenu: true,
        activeMenu: '/talente-valuation/evaluation-history',
      },
    },
    {
      path: 'collect-details/:id',
      component: () => import('@/views/talent-evaluation/components/evaluation-history/collect-details.vue'),
      props: true,
      meta: {
        title: '评价详情',
        hideInMenu: true,
        activeMenu: '/talente-valuation/evaluation-history',
      },
    },
    {
      path: 'disposition-detail/:batchNo?',
      props: true,
      component: () => import('@/views/talent-evaluation/components/evaluation-history/disposition-detail.vue'),
      meta: {
        hideInMenu: true,
        title: '评价配置',
        activeMenu: '/talente-valuation/evaluation-history',
      },
    },
    // {
    //   path: 'add',
    //   props: true,
    //   component: () => import('@/views/evaluation/detail.vue'),
    //   meta: {
    //     // hideInMenu: true
    //     activeMenu: '/talente-valuation/evaluation-history',
    //   },
    // },
  ],
};

export default routes;
